import {
  Analytics,
  getAnalytics,
  logEvent,
  setUserProperties as setUserProps,
} from 'firebase/analytics'
import { FirebaseApp, initializeApp } from 'firebase/app'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

let app: FirebaseApp
let analytics: Analytics

const getInstanceFirebase = (): Analytics => {
  analytics = getAnalytics(app)
  return analytics
}
const initializeFirebase = (): FirebaseApp => {
  app = initializeApp(firebaseConfig)
  getInstanceFirebase()
  return app
}

const ERROR = (error: Error): void => {
  if (process.env.NODE_ENV !== 'test') {
    logEvent(analytics, 'exception', {
      description: error.message,
      fatal: true,
    })
  }
}

interface IRegisterEvent {
  categoria: string
  acao: string
  local: string
}

interface IPageViewEvent {
  title: string
  path: string
}

const registerEvent = ({ categoria, acao, local }: IRegisterEvent): void => {
  if (process.env.NODE_ENV !== 'test') {
    logEvent(analytics, acao, {
      category: categoria,
      label: local,
    })
  }
}

const pageViewEvent = ({ title, path }: IPageViewEvent): void => {
  if (process.env.NODE_ENV !== 'test') {
    logEvent(analytics, 'page_view', {
      page_location: path,
      page_path: path,
      page_title: title,
    })
  }
}

const loginEvent = (): void => {
  if (process.env.NODE_ENV !== 'test') {
    logEvent(analytics, 'login', {
      method: 'email',
    })
  }
}

interface ISetUserProperties {
  id: string
  profile: string
  name: string
}

const setUserPropertiesFirebase = ({
  id,
  profile,
  name,
}: ISetUserProperties): void => {
  if (process.env.NODE_ENV !== 'test') {
    setUserProps(analytics, {
      id,
      profile,
      name,
    })
  }
}

export {
  ERROR,
  registerEvent,
  initializeFirebase,
  getInstanceFirebase,
  pageViewEvent,
  setUserPropertiesFirebase,
  loginEvent,
}
